module.exports = __webpack_public_path__ + "static/img/tingzhenqi.f53468f.png";


//////////////////
// WEBPACK FOOTER
// ./static/tingzhenqi.png
// module id = 1qhM
// module chunks = 1